import './skeleton.css'

import * as React from 'react'

import { Box, Flex, Skeleton } from 'components/ds'

/** One labelled field: a short label bar above a full-width input bar. */
function SkeletonField({ label = '40%' }: { label?: string }) {
  return (
    <Box>
      <Box mb="1" width={label}>
        <Skeleton height="12px" />
      </Box>
      <Skeleton height="32px" />
    </Box>
  )
}

/**
 * Placeholder shaped like the Metadata tab so the modal keeps its layout
 * while a track loads, and real fields swap in without the content jumping.
 */
export function MetadataFormSkeleton(): React.ReactElement<'div'> {
  return (
    <div
      className="MetadataFormSkeleton"
      aria-busy="true"
      aria-label="Loading track metadata"
    >
      {/* Artwork tile beside the Title / Artist / Album stack. */}
      <Flex gap="4" mb="4">
        <Box width="148px" flexShrink="0">
          <Skeleton height="148px" />
        </Box>
        <Flex direction="column" gap="3" flexGrow="1" minWidth="0">
          <SkeletonField label="25%" />
          <SkeletonField label="30%" />
          <SkeletonField label="28%" />
        </Flex>
      </Flex>

      {/* Composer / Genre, then full-width Grouping. */}
      <div className="MetadataFormSkeleton__row">
        <SkeletonField label="45%" />
        <SkeletonField label="35%" />
      </div>
      <Box mb="4">
        <SkeletonField label="30%" />
      </Box>

      {/* The short numeric fields and identifiers. */}
      <div className="MetadataFormSkeleton__row">
        <SkeletonField label="30%" />
        <SkeletonField label="40%" />
      </div>
      <div className="MetadataFormSkeleton__row">
        <SkeletonField label="35%" />
        <SkeletonField label="45%" />
      </div>

      {/* Comments. */}
      <Box mb="1" width="30%">
        <Skeleton height="12px" />
      </Box>
      <Skeleton height="96px" />
    </div>
  )
}

/**
 * Placeholder for the segmented tab strip, used while the set of tabs isn't
 * known yet (the bulk editor's initial load).
 */
export function MetadataTabsSkeleton(): React.ReactElement<'div'> {
  return (
    <div className="MetadataTabsSkeleton" aria-hidden="true">
      <Skeleton height="32px" />
    </div>
  )
}
